import React, {Component} from 'react'
import {reduxForm, Field, change} from 'redux-form'
import DatePickerFormComponent from './redux-form/DatePickerFormComponent'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import { connect } from 'react-redux'
import VirtualizedSelectFormComponent from '../components/redux-form/VirtualizedSelectFormComponent'

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

class BackOfficeUserDetailMarkForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      fetchingMarkTypes: false,
      freeSelectMode: false,
      category: null,
      allMarkTypes: [],
      filteredMarkTypes: [],
      markTypeId: null,
      markRules: {},
      errorFetchingRules: false,
      vehicles: [''],
      price: {},
      quantity: 1,
      errorFetchingPrice: false,
      error: false,
      markTypeDocuments: [],
      currentArea: null,
      selectedMarkType: null,
      selectedMarkTypeCategory: null,
      selectedTotalPrice: 0
    }

    this.onFreeSelectModeChange = this.onFreeSelectModeChange.bind(this)
    this.onUserCategorySelected = this.onUserCategorySelected.bind(this)
    this.onMarkTypeSelected = this.onMarkTypeSelected.bind(this)
    this.onVehicleChange = this.onVehicleChange.bind(this)
    this.onAddQuantity = this.onAddQuantity.bind(this)
    this.onRemoveQuantity = this.onRemoveQuantity.bind(this)
    this.countMarks = this.countMarks.bind(this)
  }

  async componentWillMount () {
    try {
      this.setState({loading: true, error: false})
      const markTypes = await SostaOnlineApiService.fetchMarkTypes()

      this.setState({
        allMarkTypes: markTypes.data,
        filteredMarkTypes: markTypes.data,
        loading: false
      })
    } catch (e) {
      console.error(e)
      this.setState({error: true, loading: false})
    }
  }

  async fetchFilteredMarkTypes () {
    let cat = this.props.user.categories.filter(item => item.id === parseInt(this.state.category))
    if (cat.length > 0) {
      this.setState({fetchingMarkTypes: true})
      let area

      if (cat[0].parkingInDifferentPlace) {
        area = this.props.user.parkSpaceAddress.areaId
      } else if (cat[0].resident) {
        area = this.props.user.residenceArea.id
      } else {
        area = ''
      }

      const markTypes = await SostaOnlineApiService.fetchMarkTypesByCategoryAndAreaId(cat[0].id, area)
      console.log(markTypes)
      this.setState({
        filteredMarkTypes: markTypes.data,
        fetchingMarkTypes: false,
        rules: {},
        price: {}
      })
    }
  }

  onFreeSelectModeChange (e) {
    this.setState({freeSelectMode: e.target.checked})

    if (e.target.checked) {
      this.setState({filteredMarkTypes: this.state.allMarkTypes})
    } else {
      if (!this.state.category) {
        this.setState({filteredMarkTypes: []})
      } else {
        this.fetchFilteredMarkTypes()
      }
    }
  }

  onUserCategorySelected (e) {
    // this.props.onUserCategorySelected(e)

    this.setState({category: e.target.value}, () => {
      if (!this.state.freeSelectMode) {
        this.fetchFilteredMarkTypes()
      }
    })
  }

  async onMarkTypeSelected (e) {
    try {
      const rules = await SostaOnlineApiService.fetchMarkRulesByMarkType(e.target.value)
      if (rules.data.length === 0) {
        this.setState({errorFetchingRules: true})
        return
      }

      let cat = this.props.user.categories.filter(item => item.id === parseInt(this.state.category))
      if (cat.length <= 0) {
        return
      }

      const markTypes = this.state.allMarkTypes.filter(item => item.id + '' === e.target.value + '')[0]

      let area
      if (cat[0].parkingInDifferentPlace) {
        area = this.props.user.parkSpaceAddress.Area.code
      } else if (markTypes.fixedAreaId) {
        area = markTypes.fixedAreaId
      } else if (cat[0].resident) {
        area = this.props.user.residenceArea.code
      } else {
        area = '' // this.props.user.workArea.code
      }

      if (this.state.category && markTypes && markTypes.Categories.length > 0) {
        const foundedMarkTypeCategory = markTypes.Categories.filter(item => {
          return item.id + '' === this.state.category + ''
        })

        if (foundedMarkTypeCategory.length > 0 && foundedMarkTypeCategory[0].MarkTypeCategories) {
          this.props.change('circolazione', foundedMarkTypeCategory[0].MarkTypeCategories.circolazione)
          this.props.change('periodo', foundedMarkTypeCategory[0].MarkTypeCategories.periodo)
          this.props.change('sosta', foundedMarkTypeCategory[0].MarkTypeCategories.sosta)
          this.props.change('color', foundedMarkTypeCategory[0].MarkTypeCategories.color)
          this.setState({
            selectedMarkTypeCategory: foundedMarkTypeCategory[0].MarkTypeCategories,
          })
        }
      }

      this.setState({
        markRules: rules.data[0],
        markTypeId: e.target.value,
        selectedMarkType: markTypes,
        markTypeDocuments: markTypes.DocumentTypes,
        currentArea: area
      }, () => {
        if (this.state.markRules.id && !markTypes.fixedAreaId && this.state.currentArea.indexOf('ZTL') > -1) {
          let filteredAddress
          if (cat[0].parkingInDifferentPlace) {
            filteredAddress = this.props.addresses.filter(item => item.id === this.props.user.parkSpaceAddress.id)
          } else {
            filteredAddress = cat[0].resident
              ? this.props.addresses.filter(item => item.name === this.props.user.residenceAddress)
              : this.props.addresses.filter(item => item.name === this.props.user.workAddress)
          }

          if (filteredAddress.length > 0) {
            this.props.change('startAddress', filteredAddress[0].id)
            this.props.change('addressRoute', filteredAddress[0].percorso)
          }
        }

        if (this.state.vehicles.filter(item => item !== '').length > 0) {
          this.updatePrice()
        }
      })
    } catch (ex) {
      this.setState({error: true})
    }
  }

  onVehicleChange (e, index) {
    let newVehicles = [...this.state.vehicles]
    newVehicles[index] = e.target.value
    this.setState({vehicles: newVehicles}, () => this.updatePrice())
  }

  async updatePrice () {
    try {
      const price = await SostaOnlineApiService.fetchMarkPrice(
        this.props.user.id,
        this.state.markTypeId,
        this.state.category,
        this.printVehicles(this.state.vehicles.filter(item => item !== ''))
      )
      if (price.result !== 'ok') {
        this.setState({errorFetchingPrice: true})
        return
      }
      this.setState({price: price.data})
      this.setState({selectedTotalPrice: price.data.price})
      this.props.change('total', price.data.price)
    } catch (ex) {
      this.setState({errorFetchingPrice: true})
    }
  }

  onAddQuantity () {
    if (this.state.quantity >= 99) {
      return
    }

    this.props.dispatch(change('backofficeUserDetailMark', 'quantity', this.state.quantity + 1))
    this.setState({quantity: this.state.quantity + 1}, () => this.updatePrice())
  }

  onRemoveQuantity () {
    if (this.state.quantity <= 1) {
      return
    }

    this.props.dispatch(change('backofficeUserDetailMark', 'quantity', this.state.quantity - 1))
    this.setState({quantity: this.state.quantity - 1}, () => this.updatePrice())
  }

  printAreas (areas) {
    let string = ''
    areas.map((item, index) => {
      string = string + item.code

      if (index < areas.length - 1) {
        string = string + ', '
      }
    })
    return string
  }

  printVehicles (vehicles) {
    let string = ''
    vehicles.map((item, index) => {
      string = string + item

      if (index < vehicles.length - 1) {
        string = string + ','
      }
    })
    return string
  }

  countMarks (markTypeId) {
    return this.props.user.marks.filter(item => item.id === markTypeId).length
  }

  render () {
    const {error, handleSubmit} = this.props

    if (this.state.loading) {
      return (<div>Caricamento in corso...</div>)
    }

    if (this.state.error) {
      return (<div className="text-danger">Errore di ricezione dati</div>)
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="box">
          <div className="row form-group">
            <div className="col-md-12 checkbox text-left">
              <label>
                <input
                  checked={this.state.freeSelectMode}
                  onChange={this.onFreeSelectModeChange}
                  type="checkbox" />{' '}
                Modalità libera
              </label>
            </div>
          </div>
          <div className="row form-group">
            <div className="col-md-6 text-left">
              <label>Seleziona Categoria</label>
              <Field onChange={this.onUserCategorySelected} name="categoryId" className="form-control" component="select" required>
                <option value={''}>Seleziona Categoria Utente</option>
                {this.props.user.categories.map((item, index) =>
                  <option key={item.id + '-' + index} value={item.id}>{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</option>
                )}
              </Field>
            </div>
            <div className="col-md-6 text-left">
              <label>Seleziona Tipo Contrassegno</label>
              <Field onChange={this.onMarkTypeSelected} name="markTypeId" className="form-control" component="select" required>
                {this.state.filteredMarkTypes.length > 0 && <option value={''}>Seleziona Contrassegno</option>}
                {this.state.filteredMarkTypes.length > 0 ? this.state.filteredMarkTypes.map(item =>
                  <option key={item.id} value={item.id}>{item.label + ' - aree: ' + this.printAreas(item.Areas)}</option>) : <option value={0}>Nessun Contrassegno disponbile</option>}
              </Field>
            </div>
          </div>

          {this.state.errorFetchingRules && <div className="row">
            <div className="col-12 text-danger">
              Errore nella ricezione delle regole del contrassegno
            </div>
          </div> }

          {this.state.markRules.id ? <div className="row form-group">
            {(this.state.selectedMarkTypeCategory || this.state.freeSelectMode) && (
              <div className="form-group">
                <div className="col-md-4 text-left">
                  <label>Circolazione</label>
                  <Field
                    name="circolazione"
                    className="form-control"
                    component="input"
                  />
                </div>
                <div className="col-md-4 text-left">
                  <label>Periodo</label>
                  <Field
                    name="periodo"
                    className="form-control"
                    component="input"
                  />
                </div>
                <div className="col-md-4 text-left">
                  <label>Sosta</label>
                  <Field
                    name="sosta"
                    className="form-control"
                    component="input"
                  />
                </div>
                <Field
                    name="color"
                    component="input"
                    type="hidden"
                />
              </div>
            )}
            {this.state.markTypeDocuments.length > 0 && (
              <div className="col-md-12 text-left">
                <label>Documenti necessari:</label>
                <ul>
                  {this.state.markTypeDocuments.map((item, index) => {
                    return (
                      <li key={`markTypeDocument-${index}`}>
                        {item.name}
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
            <div className="col-md-12 text-left">
              <span
                className={this.state.vehicles.length > this.state.markRules.vehicleLimit
                  ? 'text-danger'
                  : 'text-primary'}>
                {this.state.vehicles.length} / {this.state.markRules.vehicleLimit}
              </span>
              {' '}
              <button
                type="button"
                className="btn btn-xs btn-update btn-add-card"
                onClick={() => {
                  this.setState({
                    vehicles: [...this.state.vehicles, '']
                  }, () => {
                    this.updatePrice()
                    this.props.dispatch(change('backofficeUserDetailMark', `vehicle${this.state.vehicles.length - 1}`, ''))
                  })
                }}>
                Aggiungi Veicolo
              </button>
            </div>
          </div> : null}

          {this.state.markRules.id ? this.state.vehicles.map((item, index) => (<div key={index} className="row form-group">
            <div className="col-md-6 text-left">
              <label>Seleziona {index + 1}° Veicolo</label>
              <Field onChange={(e) => this.onVehicleChange(e, index)} name={'vehicle' + index} className="form-control" component="select" required>
                {(!this.props.user.vehicles) && <option value={''}>Questo Utente non ha Veicoli</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length === 0) && <option value={''}>
                  Questo Utente non ha Veicoli
                </option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                <option value={''}>Seleziona un veicolo</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                this.props.user.vehicles.map(item =>
                  <option key={item.id} value={item.id}>
                    {item.plate_number + ' - ' + item.VehiclePowerSupply.name}
                  </option>)}
              </Field>
              <button
                onClick={() => this.setState({vehicles: this.state.vehicles.filter((_, i) => i !== index)}, () => this.updatePrice())}
                type="button"
                className="btn btn-xs btn-danger">
                Rimuovi Veicolo
              </button>
            </div>
          </div>)) : null}

          {(this.state.markRules.id && !this.state.selectedMarkType.fixedAreaId && this.state.currentArea.indexOf('ZTL') > -1) && <div className="row form-group">
            <div className="col-md-12 text-left">
              <label>Indirizzo di Partenza</label>
              <Field
                name="startAddress"
                options={this.props.addresses.map(item => {
                  return {
                    label: item.name,
                    value: item.id
                  }
                })} component={VirtualizedSelectFormComponent} required />
            </div>
            <div className="col-md-12 text-left">
              <label>Percorso ZTL</label>
              <Field
                name="addressRoute"
                component="textarea"
                className="form-control"
                required
              />
            </div>
          </div> }

          {/* (this.state.price.price > 0) && <div className="row">
            {<div className="col-md-6 text-left">
              <label className={this.state.quantity > (this.state.markRules.marksLimit - this.countMarks(this.state.markTypeId)) ? 'text-danger' : null}>
                Quantit&agrave; ({this.state.quantity + this.countMarks(this.state.markTypeId)} / {this.state.markRules.marksLimit}):
              </label>
              <div className="input-group" style={{marginBottom: '10px'}}>
                <span className="input-group-btn">
                  <button onClick={() => this.onRemoveQuantity()} type="button" className="btn btn-default btn-number">
                    <span className="glyphicon glyphicon-minus">{}</span>
                  </button>
                </span>
                <Field onChange={(e) => this.setState({quantity: parseInt(e.target.value)})} component="input" type="text" name="quantity" className="form-control" style={{padding: '6px', verticalAlign: 'middle', display: 'inline-block', textAlign: 'center', zIndex: '0'}} required />
                <span className="input-group-btn">
                  <button onClick={this.onAddQuantity} type="button" className="btn btn-default btn-number">
                    <span className="glyphicon glyphicon-plus">{}</span>
                  </button>
                </span>
              </div>
            </div> */}

          {(this.state.markTypeId) && (
            <div className="row">
              <div className="col-md-6 text-left">
                <label>Prezzo</label>
                <div className="input-group" style={{marginTop: 12, marginBottom: 12}}>
                  <div className="input-group-addon">€</div>
                  <Field
                    name="total"
                    component="input"
                    type="number"
                    className="form-control"
                    onChange={e => {
                      if (!e.target.value) {
                        this.setState({selectedTotalPrice: 0})
                        this.props.change('total', 0)
                      } else {
                        this.setState({selectedTotalPrice: e.target.value})
                        this.props.change('total', e.target.value)
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {this.state.selectedTotalPrice > 0 && <div className="row">
            <div className="col-md-6 text-left">
              <label>Totale</label>
              <h4>€ {Number(this.state.selectedTotalPrice).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h4>
            </div>
          </div>}

          {this.state.selectedTotalPrice > 0 && <div className="row">
            <div className="col-md-6 text-left">
              <label>Metodo di Pagamento</label>
              <div className="radio">
                <label><Field component="input" type="radio" name="method" value="SPORTELLO_POS" required /> POS</label>
              </div>
              <div className="radio">
                <label><Field component="input" type="radio" name="method" value="SPORTELLO_CONTANTI" required /> CONTANTI</label>
              </div>
            </div>
          </div>}

          {this.state.price.price === 0 && <div className="text-primary">
            Contrassegno gratuito
          </div>}

          {this.props.loading && <div className="well">Creazione Contrassegno in Corso...</div> }

          {this.props.markCreateError && <div className="panel panel-danger">
            {this.props.markCreateError}
          </div>}

          {this.props.markSuccess && <div>
            <div className="row">
              <div className="col-md-4 col-md-offset-4 ">
                <div className="contrassegno">
                  <h4 className="contrassegno-h">Contrassegno creato correttamente!</h4>
                </div>
              </div>
            </div>
          </div>}

          <p>
            <button type="submit" className="btn btn-lg btn-green">
              Crea Contrassegno
            </button>
          </p>
        </div>
      </form>
    )
  }
}

BackOfficeUserDetailMarkForm = reduxForm({
  form: 'backofficeUserDetailMark'
})(BackOfficeUserDetailMarkForm)

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserDetailMarkForm)



// WEBPACK FOOTER //
// ./src/components/BackOfficeUserDetailMarkForm.js